import { useParams } from 'react-router'
import invariant from 'tiny-invariant'

export {
  useFindingQuickViewCounts,
  useFindingQuickViewState,
  useGetScanAndRepository,
  useGetScanLifecycleState,
  useSearchQueryParam,
  useSortDirectionQueryParam,
  useSortQueryParam,
  useSwitchToAnalyzedOnFirstBatchComplete,
  type ScanLifecycleState,
  type UseGetScanLifecycleStateReturn,
} from '../../hooks/scan-hooks.ts'

export function useScanDetailsPageParams() {
  const { scanId } = useParams<{ scanId: string }>()
  invariant(scanId, 'scanId must be available from route params')
  return { scanId }
}
